import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';
import { GuidedCreation } from 'src/app/beans/guided-creation/guided.creation.bean';

@Injectable({
  providedIn: 'root',
})
export class HubRequest {
  constructor(
    private network: NetworkManager,
    private utils: UtilsManager,
  ) {}

  /**
   *
   * @param token
   */
  list(token: string) {
    let url = this.network.CodaQApi() + CQWebappApi.HUB_LIST;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    return this.network.http().put(url, null, { headers });
  }

  /**
   *
   * @param token
   * @param pharma
   */
  createComplete(token: string, data: string, orgId?: number) {
    let url = this.network.CodaQApi() + CQWebappApi.GUIDED_CREATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    //form.set( RequestField.HUB_ID, hubId.toString () );
    if (orgId) form.set(RequestField.ORGANIZATION_ID, orgId.toString());
    form.set(RequestField.DATA, data.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }
}
